import { useMemo } from 'react';

export function useActions<T extends Record<string, (...args: any[]) => any>>(
  actions: T,
  dispatch: React.Dispatch<any>
): { [k in keyof T]: (...p: Parameters<T[k]>) => void } {
  return useMemo(
    () =>
      Object.fromEntries(
        Object.entries(actions)
          .filter(([, action]) => typeof action === 'function')
          .map(([name, action]) => [name, (...args) => dispatch(action(...args))])
      ),
    [actions, dispatch]
  ) as any;
}
